import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { exchangeCodeForTokens, verifyState } from '../utils/auth';
import './CallbackPage.css';

const CallbackPage = ({ onAuthSuccess }) => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const processedRef = useRef(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (processedRef.current) {
      console.log('Callback already processed, skipping');
      return;
    }
    const handleCallback = async () => {
      try {
        const urlParams = new URLSearchParams(window.location.search);
        const code = urlParams.get('code');
        const state = urlParams.get('state');
        const error = urlParams.get('error');
        if (error) {
          throw new Error(`OAuth error: ${error}`);
        }
        if (!code) {
          throw new Error('Authorization code not found');
        }
        console.log('About to verify state. URL params:', {
          code: code,
          state: state,
          error: error,
          fullURL: window.location.href
        });
        console.log('Manual storage check:', {
          localStorage_oauth_state: localStorage.getItem('oauth_state'),
          sessionStorage_oauth_state: sessionStorage.getItem('oauth_state'),
          window_oauth_state: window.__oauth_state,
          received_state: state
        });
        const stateVerificationResult = verifyState(state);
        console.log('State verification result:', stateVerificationResult);
        if (!stateVerificationResult) {
          console.error('State verification failed in CallbackPage');
          throw new Error('Invalid state parameter. This may be due to browser refresh or session expiry. Please try logging in again.');
        }
        console.log('State verification successful, proceeding with token exchange');
        processedRef.current = true;
        console.log('Starting token exchange...');
        await exchangeCodeForTokens(code);
        console.log('Token exchange completed successfully');
        console.log('Calling onAuthSuccess callback');
        onAuthSuccess();
        console.log('Authentication flow completed successfully');
        setTimeout(() => {
          navigate('/dashboard');
        }, 500);
      } catch (err) {
        console.error('Authentication error:', err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    handleCallback();
  }, [onAuthSuccess]);

  if (loading) {
    return (
      <div className="callback-container">
        <div className="callback-card">
          <div className="spinner"></div>
          <h2>Authenticating...</h2>
          <p>Please wait while we complete your login</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="callback-container">
        <div className="callback-card error">
          <h2>Authentication Failed</h2>
          <p>{error}</p>
          <button onClick={() => window.location.href = '/'}>
            Return to Login
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="callback-container">
      <div className="callback-card success">
        <h2>Login Successful!</h2>
        <p>Redirecting to dashboard...</p>
      </div>
    </div>
  );
};

export default CallbackPage;
